import type { ComponentChildren } from 'preact'
import { useMemo } from 'preact/hooks'
import { useEvent } from '../events/EventContext'
import { EventShell } from '../events/EventShell'
import { planningDays } from '../planning/grid'
import { useOrganizerData } from './OrganizerData'
import { eventDates, unreadMessages, volunteersToAssign } from './overview'

/** The organizer space's navigation, with volunteers to assign and unread messages. */
export function OrganizerShell({ children }: { children: ComponentChildren }) {
  const { event } = useEvent()
  const { volunteers, conversations, groups, shifts } = useOrganizerData()
  const dates = useMemo(
    () => eventDates(planningDays(shifts.data ?? [], event)),
    [shifts.data, event.starts_on, event.ends_on],
  )
  const badges = {
    pending: volunteersToAssign(volunteers.data ?? []).length,
    unread: unreadMessages(conversations.data ?? [], groups.data ?? []),
  }
  return (
    <EventShell badges={badges} dates={dates}>
      {children}
    </EventShell>
  )
}
